// extracted by mini-css-extract-plugin
export default {"unauthorizedDialog":"unauthorizedDialog__7sJyn","dialog-confirm":"dialog-confirm","modalHeader":"modalHeader"};